"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractFilters = void 0;
var dom_interact_1 = require("../helpers/dom-interact");
var handle_url_1 = require("../helpers/handle-url");
var specialCasesAcrossProject_1 = require("../helpers/specialCasesAcrossProject");
var tracker_1 = __importDefault(require("../helpers/tracker"));
var Views_1 = require("../Modules/Views");
var HttpRequest_1 = require("../Modules/HttpRequest");
var TrackingTypes_1 = require("../helpers/TrackingTypes");
var AbstractFilters = /** @class */ (function (_super) {
    __extends(AbstractFilters, _super);
    function AbstractFilters(el, options) {
        var _this = _super.call(this, el) || this;
        _this.events = [
            { name: 'click', queries: ['.js-tab-content'], callback: function (e) { return _this.onFilterItemClick(e); } },
            { name: 'click', queries: ['.js-reset-filters'], callback: function () { return _this.onResetFiltersClick(); } },
        ];
        _this.customEvents = [];
        _this.filtersBeingUsed = {};
        _this.options = options;
        _this.filtersBeingUsed = (0, handle_url_1.getUrlParams)();
        _this.filterHolder = (0, dom_interact_1.getHTMLElement)(el, '.js-filter-holder');
        setTimeout(function () { return _this.mergeEvents(); });
        return _this;
    }
    AbstractFilters.prototype.mergeEvents = function () {
        this.events = __spreadArray(__spreadArray([], this.events, true), this.customEvents, true);
        this.attachEvents();
    };
    AbstractFilters.prototype.onFilterItemClick = function (e) {
        var target = e.target;
        var currentTarget = e.currentTarget;
        var filterType = currentTarget.getAttribute('data-facet');
        var filterValue = (0, dom_interact_1.getAttributeFromTargetBubblingUpTo)('data-facet-item', target, currentTarget);
        if (!filterType) {
            throw new Error('Filter type not found in element');
        }
        // If no value is because clicked on the container and not in a filter value
        if (!filterValue) {
            return;
        }
        var isFilterBeingUsed = this.isFilterBeingUsed(filterType, filterValue);
        this.updateFiltersBeingUsed(filterType, filterValue, isFilterBeingUsed);
        this.sendRequest();
        this.trackClickOnFilterValue(filterType, filterValue, isFilterBeingUsed);
    };
    AbstractFilters.prototype.isFilterBeingUsed = function (filterType, filterValue) {
        return (Object.prototype.hasOwnProperty.call(this.filtersBeingUsed, filterType) &&
            this.filtersBeingUsed[filterType] === filterValue);
    };
    AbstractFilters.prototype.updateFiltersBeingUsed = function (filterType, filterValue, isFilterBeingUsed) {
        this.filtersBeingUsed = (0, handle_url_1.getUrlParams)();
        if (isFilterBeingUsed) {
            delete this.filtersBeingUsed[filterType];
        }
        else {
            this.filtersBeingUsed[filterType] = filterValue;
        }
        if (Object.prototype.hasOwnProperty.call(this.filtersBeingUsed, 'page')) {
            delete this.filtersBeingUsed.page;
        }
        (0, handle_url_1.setUrl)((0, handle_url_1.objectToParams)(this.filtersBeingUsed));
    };
    AbstractFilters.prototype.onResetFiltersClick = function () {
        this.resetFilters();
        this.trackResetAllFilters();
    };
    AbstractFilters.prototype.resetFilters = function () {
        this.filtersBeingUsed = {};
        (0, handle_url_1.setUrl)();
        this.sendRequest();
    };
    AbstractFilters.prototype.sendRequest = function () {
        var _this = this;
        this.dispatchEvent(new CustomEvent('ajax:request:call'));
        var data = __assign({}, this.filtersBeingUsed);
        data.category = this.options.category;
        data = (0, specialCasesAcrossProject_1.handleSpecialRefinementOnParams)(data);
        HttpRequest_1.Xhr.getJson(this.options.apiEndpoint, data)
            .then(function (response) { return _this.handleSuccessfulRequest(response); })
            .catch(function (xhrResponse) {
            _this.handleErrorRequest();
            HttpRequest_1.Xhr.logXhrPromiseRejection(xhrResponse, 'AbstractFilters on sendRequest');
        });
    };
    AbstractFilters.prototype.successfulRequestCallback = function () { };
    AbstractFilters.prototype.handleSuccessfulRequest = function (response) {
        this.rerenderFilters(response.filters);
        this.successfulRequestCallback();
        this.dispatchEvent(new CustomEvent('ajax:request:done'), response);
    };
    AbstractFilters.prototype.errorRequestCallback = function () { };
    AbstractFilters.prototype.handleErrorRequest = function () {
        this.errorRequestCallback();
        this.dispatchEvent(new CustomEvent('ajax:request:done'));
    };
    AbstractFilters.prototype.rerenderFiltersCallback = function () { };
    AbstractFilters.prototype.rerenderFilters = function (filtersNewMarkup) {
        var placeHolder = document.createElement('div');
        placeHolder.innerHTML = filtersNewMarkup;
        this.detachEvents();
        this.el.innerHTML = placeHolder.innerHTML;
        this.rerenderFiltersCallback();
        this.attachEvents();
    };
    AbstractFilters.prototype.trackClickOnFilterValue = function (filterType, filterValue, isResetFilter) {
        tracker_1.default.track({
            category: this.options.trackingCategory,
            action: "filter_".concat(filterType),
            label: isResetFilter ? TrackingTypes_1.TrackingData.LABEL_RESET_FILTER : filterValue,
        });
    };
    AbstractFilters.prototype.trackResetAllFilters = function () {
        tracker_1.default.track({
            category: this.options.trackingCategory,
            action: TrackingTypes_1.TrackingData.ACTION_FILTER_RESET_ALL,
        });
    };
    return AbstractFilters;
}(Views_1.AbstractView));
exports.AbstractFilters = AbstractFilters;
